import { render, staticRenderFns } from "./SubjectSeo.vue?vue&type=template&id=8dbd9f38&"
import script from "./SubjectSeo.vue?vue&type=script&lang=js&"
export * from "./SubjectSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports